export const StrengthIcon = ({ width, height }: { width?: number; height?: number }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width || "19"}
    height={height || "13"}
    viewBox="0 0 19 13"
    fill="none"
  >
    <path
      d="M2.80281 5.86216C2.68813 5.52199 2.3194 5.33919 1.97922 5.45387C1.63905 5.56855 1.45625 5.93728 1.57093 6.27746L3.27682 11.3376C3.3915 11.6778 3.76023 11.8606 4.10041 11.7459C4.44058 11.6313 4.62338 11.2625 4.5087 10.9224L2.80281 5.86216Z"
      fill="#BAFD4F"
    />
    <path
      d="M4.14265 4.42581C4.02797 4.08563 3.65924 3.90283 3.31907 4.01751C2.97889 4.13219 2.79609 4.50092 2.91077 4.8411L5.21085 11.6638C5.32553 12.004 5.69426 12.1868 6.03444 12.0721C6.37461 11.9574 6.55741 11.5887 6.44273 11.2485L4.14265 4.42581Z"
      fill="#BAFD4F"
    />
    <path
      d="M15.748 7.14084C15.8627 7.48102 16.2314 7.66382 16.5716 7.54914C16.9117 7.43446 17.0945 7.06573 16.9799 6.72555L15.274 1.66536C15.1593 1.32519 14.7905 1.14239 14.4504 1.25707C14.1102 1.37175 13.9274 1.74048 14.0421 2.08065L15.748 7.14084Z"
      fill="#BAFD4F"
    />
    <path
      d="M14.4238 8.56342C14.5384 8.90359 14.9072 9.08639 15.2473 8.97171C15.5875 8.85703 15.7703 8.4883 15.6556 8.14813L13.3556 1.3254C13.2409 0.985223 12.8721 0.802423 12.532 0.917103C12.1918 1.03178 12.009 1.40052 12.1237 1.74069L14.4238 8.56342Z"
      fill="#BAFD4F"
    />
    <path
      d="M11.9426 4.88155L6.18119 6.82384C5.82008 6.94558 5.62532 7.33488 5.74617 7.69337C5.86703 8.05186 6.25773 8.24379 6.61884 8.12206L12.3803 6.17977C12.7414 6.05803 12.9361 5.66873 12.8153 5.31023C12.6944 4.95174 12.3037 4.75982 11.9426 4.88155Z"
      fill="#BAFD4F"
    />
    <path
      d="M16.2852 3.4052L16.939 3.18477C17.2991 3.06338 17.6919 3.25811 17.8133 3.61819C17.9347 3.97828 17.7399 4.37107 17.3799 4.49246L16.726 4.71289L16.2884 3.41467L16.2852 3.4052Z"
      fill="#BAFD4F"
    />
    <path
      d="M1.14532 8.51021L1.79917 8.28979L2.23682 9.588L1.58298 9.80843C1.22289 9.92982 0.830099 9.73509 0.708706 9.37501C0.587313 9.01492 0.782038 8.62213 1.14213 8.50074L1.14532 8.51021Z"
      fill="#BAFD4F"
    />
  </svg>
)
